import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CheckboxComponent
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {

  @Input() label!: string;
  @Output() change: EventEmitter<any> = new EventEmitter<boolean>();

  checked!: boolean;
  disabled!: boolean;

  constructor(private readonly cd: ChangeDetectorRef) { }

  onChange = (_: boolean) => {};
  onTouched = () => {};

  registerOnChange(onChange: () => void): void {
    this.onChange = onChange;
    this.cd.markForCheck();
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  writeValue(checked: boolean): void {
    this.checked = checked;
  }
  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.cd.markForCheck();
  }

  onChecked(change: MatCheckboxChange) {
    this.checked = change.checked;
    this.onChange(this.checked);
    this.change.emit(this.checked);
  }

}

